// MMGY IO types offered on the campaign create forms.
//
//   mmgy       — MMGY-format insertion order PDF + Excel proposal(s)
//   traveldesk — TravelDesk insertion order PDF + Excel proposal(s)
//   plan-only  — the Excel media plan IS the insertion order: no PDF, the
//                campaign processor is skipped and the launcher builds the IO
//                from the Excel (campaign-services plan_only_io.py)
//
// Plan-only runs only on the MMGY DV360/TTD pipeline, and for one destination
// at a time: a plan row whose DSP column names neither DSP would otherwise be
// booked on both.

export const MMGY_PLAN_ONLY_IO_TYPE = 'plan-only';
const MMGY_PLAN_ONLY_PLATFORMS = ['dv360', 'ttd'];

export const isMmgyPlanOnly = (ioType) => ioType === MMGY_PLAN_ONLY_IO_TYPE;

export const isMmgyPlanOnlyAvailable = (destinations = []) => {
  const list = (Array.isArray(destinations) ? destinations : [destinations]).filter(Boolean);
  return list.length === 1 && MMGY_PLAN_ONLY_PLATFORMS.includes(list[0]);
};

// The IO type a submit should carry: the picked one, except plan-only on a
// destination that cannot run it falls back to the default.
export const effectiveMmgyIoType = (ioType, destinations = []) => (
  isMmgyPlanOnly(ioType) && !isMmgyPlanOnlyAvailable(destinations) ? 'mmgy' : (ioType || 'mmgy')
);

export const MMGY_IO_TYPE_HELP = {
  mmgy: 'TravelDesk IOs skip MMGY-specific processing',
  traveldesk: 'TravelDesk IOs skip MMGY-specific processing',
  [MMGY_PLAN_ONLY_IO_TYPE]: 'Plan only: upload just the Excel media plan — no IO PDF. The campaign processor is skipped and every campaign, budget and flight date comes from the Excel.',
};
